<cv-module-custom-setting-section class="d-flex ml-3 pl-1" *ngIf="navigationService.companyPartner === 8 && moduleManager.settingsView === 'slideout'" [moduleManager]="moduleManager" inside="emp">
    <div class="custom-setting-section-inside-body ml-2 pl-1">
        <div class="body-2 color-whaleTail mb-1">Teams</div>
        <cv-single-attribute-selector *ngIf="moduleManager.container.settingsOpen" class="d-flex" attributeName="Teams" [attributeType]="1" [pageName]="moduleManager.getModuleKey() + '_temp'" [autoWidth]="false"></cv-single-attribute-selector>
    </div>
</cv-module-custom-setting-section>
